
import { mapState } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  data() {
    return {
      story: {},
      showPaymentForm: false,
      activeSection: 0
    }
  },
  async mounted() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'begin_checkout',
      'items': this.order.products,
      'value': this.order.totals.total,
      'currency': 'USD'
    })


    this.$storybridge.on(['input', 'published', 'change'], (event) => {
      if (event.action === 'input') {
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content
        }
      } else {
        window.location.reload()
      }
    })

    if (!this.menu) {
      this.$router.push('/locations')
    } else if (!this.order) {
      this.$router.push('/order')
    } else if (this.order.products.length < 1) {
      this.$router.push('/order/')
    } else {
      await this.$api.validateOrder()
      if (!this.user || this.user.payments.length == 0) {
        this.showPaymentForm = true
      }
    }

    /* order duble confirmation listener */
    this.$nuxt.$on('orderConfirmed', () => {
      this.$store.commit('setOrderConfirm', false)
      /* submit order after confirmed */
      this.submitOrder()
    })

    window.addEventListener('scroll', this.scroll)

    // Apply promo code if it's set
    if (this.offerToApply) {
      const valid = await this.$api.addCoupon(this.offerToApply.cred.toUpperCase())
      if (valid) {
        this.$store.commit('setOfferToApply', null)
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll)
  },
  async asyncData({ $storyapi, store, route }) {
    try {
      const { data } = await $storyapi.get(`cdn/stories/order/checkout`, {
        version: process.env.SB_VERSION
      })
      return {
        story: data.story
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapState(['location', 'menu', 'order', 'user', 'errors', 'handoff', 'offerToApply', 'guestUser', 'channel', 'handoffToggle']),
    curbside() {
      if (!this.order && !this.order.handoff) return false
      return this.order.handoff === 'curbside' && this.order.custom.length > 0
    },
    delivery() {
      if (!this.order && !this.order.handoff) return false
      return this.order.handoff === 'delivery'
    },
    paymentMethods() {
      return !!(
        this.user &&
        this.user.payments &&
        this.user.payments.length > 0
      )
    },
    mobile() {
      return (this.$mq == 'sm' || this.$mq == 'md')
    },

    checkOrderProduct() {
      if (this.channel == 'catering') {
        if (this.order && this.order.products && this.order.products.length > 0 && this.order.totals.total < 150 && this.handoffToggle == 'delivery') {
          return true
        } else {
          return false
        }
      }
    },

    checkOrderTime() {
      if (this.order && this.order.time && !this.order.time.wanted) {
        return true
      } else {
        return false
      }
    },
    donationsContent() {
      return this.story?.content?.body?.find(blok => blok.component.toLowerCase() === 'donations')
    }
  },
  methods: {
    toggleCart() {
      this.$store.commit('setShowCart', !this.showCart)
    },
    togglePaymentForm(bool) {
      this.showPaymentForm = bool
    },
    async submitOrder() {
      this.$store.commit('setErrors', [])
      const errors = []

      const termsCheckbox = document.querySelector('.customer-details input[name="terms"]')
      if (termsCheckbox && !termsCheckbox.checked) {
        errors.push('You must accept the terms & conditions to continue.')
      }

      // Add validation for order details
      if (!this.user && this.guestUser) {
        if (!this.handoff.first_name) {
          errors.push('First name is required.')
        }
        if (!this.handoff.last_name) {
          errors.push('Last name is required.')
        }
        if (!this.handoff.email) {
          errors.push('Email is required.')
        }
        if (!this.handoff.phone) {
          errors.push('Phone number is required.')
        }

      } else if (this.guestUser === null && !this.user) {
        if (!this.handoff.email) {
          errors.push('Email is required.')
        }
      }

      if (this.order.handoff == 'curbside' && this.order.custom.length > 0) {
        let vehicleError = false
        this.order.custom.map((c) => {
          if (!this.handoff[c.label]) {
            vehicleError = true
            errors.push(`Please specify ${c.label} for your vehicle.`)
          }
        })
        if (!vehicleError) {
          if (this.order.custom) {
            const fields = []
            this.order.custom.map((c) => {
              if (this.handoff[c.label]) {
                fields.push({
                  id: c.id,
                  value: this.handoff[c.label]
                })
              }
            })
            const order = await this.$api.setCustomFields(fields)
            if (!order) {
              return
            }
          }
        }
      }
      if (errors.length > 0) {
        this.$store.commit('setErrors', errors)
      } else {
        this.$store.commit('setSubmitting', true)
      }
    },
    checkOrder() {
      this.$store.commit('setOrderConfirm', true)
    },
  },
  watch: {
    user() {
      if (this.user && this.user.payments.length > 0) {
        this.showPaymentForm = false
      } else {
        this.showPaymentForm = true
      }
    }
  }
}
